import {
  type RelatedWidget,
  type StorefrontWidget,
  StorefrontWidgetTypeAll,
  type WidgetStaticPage,
  type WidgetStaticPageCategory
} from 'ecosystem'
import { widgetApi } from '../storefront-api/widgetEndpoint'

// Extracted from ./store so that the pure factories there (categoryFactory,
// badgesFactory, deliveryFactory, isOdd, …) can be imported by client components
// without dragging in the storefront-api (and its server-only credentials store).
export async function staticPagesCategoryFactory(): Promise<RelatedWidget[]> {
  const widgets = (await widgetApi.getWidgets({
    view: 'STATIC_VIEWS',
    type: StorefrontWidgetTypeAll.WIDGET_STATIC_VIEW_CATEGORY,
    filter: {
      key: 'name',
      textValues: ['Static Pages']
    }
  })) as StorefrontWidget<WidgetStaticPageCategory>[]

  return widgets.length ? onlyActiveStaticPages(widgets[0].widget.relatedStaticPages) : []
}

/**
 * A static page category stores copies of its pages, so an inactive page is still listed in it.
 * Keeps only the pages the storefront still serves (inactive pages are not in the live list).
 */
export async function onlyActiveStaticPages(
  relatedStaticPages: RelatedWidget[]
): Promise<RelatedWidget[]> {
  if (!relatedStaticPages.length) {
    return []
  }

  const pages = (await widgetApi.getWidgets({
    view: 'STATIC_VIEWS',
    type: StorefrontWidgetTypeAll.WIDGET_STATIC_VIEW
  })) as StorefrontWidget<WidgetStaticPage>[]
  const activeIds = new Set(pages.map(({ widget }) => widget.id))

  return relatedStaticPages.filter(({ id }) => activeIds.has(id))
}
